"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.default = react_jss_1.createUseStyles({
    blockquote: function (_a) {
        var theme = _a.theme, color = _a.color;
        return (__assign(__assign({}, theme_1.getFontStyles(theme)), { fontSize: theme.fontSizes.lg, lineHeight: theme.lineHeight, backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.colors.gray[0], color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black, margin: 0, borderTopRightRadius: theme.radius.sm, borderBottomRightRadius: theme.radius.sm, borderLeft: "3px solid " + theme_1.getThemeColor({
                theme: theme,
                color: color,
                shade: theme.colorScheme === 'dark' ? 4 : 6,
            }), padding: [theme.spacing.md, theme.spacing.lg] }));
    },
    inner: {
        display: 'flex',
    },
    body: {
        flex: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    icon: function (_a) {
        var theme = _a.theme, color = _a.color;
        return ({
            color: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 6 }),
            marginRight: theme.spacing.md,
            marginTop: 2,
            width: 22,
        });
    },
    cite: function (_a) {
        var theme = _a.theme;
        return ({
            display: 'block',
            fontSize: theme.fontSizes.sm,
            marginTop: theme.spacing.xs,
            color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[6],
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        });
    },
}, { link: true });
